import React, { useEffect, useState } from "react";
import { colors } from "../utils/constant";
import { Language } from "../Languages/en";
import { Box, Button, Stack, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useLocation, useNavigate } from "react-router-dom";
import { URL } from "../utils/constant";
import usePageStatus from "../data/talons/PageStatus/usePageStatus";
import Hypoglycemia from "../pages/CRF/Hypoglycemia/Hypoglycemia";
import { useDispatch, useSelector } from "react-redux";
import {
  getRecordDate,
  getBloodSugarUpdate,
  getCalculateDate,
  getHeading,
  getHypoUpdate,
  getPageStatusData,
  getFormDate,
  getFlage,
  getSelectedVisitDate,
  getPageId,
} from "../data/selector/component.selector";
import {
  selectedVisitDate,
  setBloodSugarComponent,
  setCalculateDate,
  setHeading,
  setHypoComponent,
  setPageId,
  setPageStausData,
  setSelectedRecordDate,
} from "../data/reducer/component.reducer";
import { get, size } from "lodash";
import GlobalPageLoader from "../data/talons/loader/useFullPageLoader";
import { getLanguage } from "../data/selector/language.selector";
import { getDayCount, getSelectedDate } from "../data/selector/visits.selector";
import { setSelectedDate } from "../data/reducer/visits.reducer";
import { setInitialDate } from "../data/reducer/bloodSugarRecord.reducer";

export default function FormSidebar({ selectedVisitId, calculatedDates }) {
  const dispatch = useDispatch();
  const dateArray = useSelector(getCalculateDate);
  let { pageStatus, fetchPageStatus } = usePageStatus();
  const Language = useSelector(getLanguage);
  // console.log(Language, "languabhdbc");
  const pageStatusApiData = useSelector(getPageStatusData);
  const formHeading = pageStatusApiData?.map((item) => {
    const heading = get(item, "PageName");
    return heading;
  });

  const headingSelector = useSelector(getHeading);
  const dateSelector = useSelector(getRecordDate);

  const selectedDate = useSelector(getSelectedDate);

  const dayCountSelcetor = useSelector(getDayCount);
  let initialDate;
  if (dateArray) {
    initialDate = dateSelector ? dateSelector : dateArray[1];
  }
  const bloodSugarSelector = useSelector(getBloodSugarUpdate);
  const [FormDate, setFormDate] = useState(initialDate);
  const selectedDateIndex = dateArray?.findIndex(
    (date) => date === dateSelector
  );

  const formDateSelector = useSelector(getFormDate);
  let initialHead;
  let changeIndex;
  if (selectedDateIndex !== -1) {
    changeIndex = selectedDateIndex - 1;
  }
  let bsIndex;
  const selector = useSelector(getHypoUpdate);

  const getVisitDateIndex = useSelector(getSelectedVisitDate);

  useEffect(() => {
    if (size(initialDate) > 0 && selectedDate === null) {
      dispatch(setSelectedDate(initialDate));
      // const pageStatusobj = {
      //   pageData: pageStatusApiData[changeIndex],
      //   // date: FormDate,
      // };
      // dispatch(setPageId(pageStatusobj));
      // if (getVisitDateIndex !== -1) {
      // }
      // bsIndex = selectedDateIndex
      //   ? selectedDateIndex
      //   : bloodSugarSelector.recordNo;
    }
  }, [
    initialDate,
    selectedDate,
    changeIndex,
    getVisitDateIndex,
    selectedDateIndex,
  ]);

  initialHead = bloodSugarSelector?.heading;
  useEffect(() => {
    if (selector) {
      setBloodSugarForm({ ...BloodSugarForm, recordNo: 8 });
      dispatch(setHypoComponent(true));
    } else {
      bsIndex = bloodSugarSelector?.recordNo;
    }
  }, [selector]);
  const [BloodSugarForm, setBloodSugarForm] = useState({
    recordNo: bsIndex,
    heading: initialHead,
  });

  useEffect(() => {
    // const pageStatusobj = {
    //   pageData: pageStatusApiData[changeIndex],
    //   // date: FormDate,
    // };
    // dispatch(setPageId(pageStatusobj));
    if (bloodSugarSelector.recordNo === 8) {
      setBloodSugarForm({
        ...BloodSugarForm,
        recordNo: bloodSugarSelector.recordNo,
        // heading: initialHead,
      });
    } else {
      setBloodSugarForm({
        ...BloodSugarForm,
        recordNo: selectedDateIndex,
        // heading: initialHead,
      });
    }
  }, [dateSelector, selectedDateIndex]);
  useEffect(() => {
    // const setSelectedDatehead = headingSelector[changeIndex];
    // initialHead =
    //   selectedDateIndex !== -1 ? setSelectedDatehead : headingSelector[0];

    if (formHeading && formHeading?.length > 0) {
      dispatch(setHeading(formHeading));
    }
    if (initialDate) {
      setFormDate(initialDate);
    }
  }, [initialDate, selectedDateIndex]);
  const [HypoForm, setHypoForm] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const isFormPage = location.pathname === URL.form;

  useEffect(() => {
    fetchPageStatus();
    if (bloodSugarSelector?.recordNo === 8) {
      setHypoForm(true);
    } else {
      setHypoForm(false);
    }
    dispatch(setHypoComponent(HypoForm));
    dispatch(setBloodSugarComponent(BloodSugarForm));
    // dispatch(setSelectedDate(FormDate));
  }, [FormDate, BloodSugarForm, bloodSugarSelector]);

  const flag = useSelector(getFlage);

  // useEffect(() => {
  //   if (BloodSugarForm?.recordNo !== 1) {
  //     // setBloodSugarForm({
  //     //   ...BloodSugarForm,
  //     //   recordNo: BloodSugarForm.recordNo - 1,
  //     // });
  //   }
  // }, [flag]);

  return (
    <>
      <div
        className="formSidebar p-3"
        style={{
          // backgroundColor: colors.blue3,
          backgroundColor: colors.grey2,
          zIndex: 4,
        }}
      >
        <Typography fontSize={"18px"} className="fw-bolder">
          {" "}
          {selectedVisitId?.VisitName}
        </Typography>
        <div className="d-flex justify-content-between align-items-center px-1 mt-3">
          <h6 className="fw-bold">{selectedDate}</h6>
        </div>
        <Stack sx={{ mx: 1, mt: 2 }}>
          {GlobalPageLoader()}
          {formHeading?.map((heading, index) => {
            let headNum;
            index = index + 1;
            return (
              <>
                <Stack
                  key={index}
                  onClick={(e) => {
                    if (!isFormPage) {
                      // Handle click logic only if the Stack is not disabled
                      setFormDate(dateArray[index]);
                      dispatch(setSelectedDate(dateArray[index]));
                      dispatch(setSelectedRecordDate(dateArray[index]));
                      headNum = e.target.innerText;
                      const addItem = "";
                      const newArray = [addItem, ...pageStatusApiData];
                      const pageStatusobj = {
                        pageData: newArray[index],
                        date: dateArray[index],
                      };
                      dispatch(setPageId(pageStatusobj));
                      if (headNum === formHeading?.slice(-1)[0]) {
                        dispatch(
                          setBloodSugarComponent({
                            recordNo: formHeading?.length,
                          })
                        );
                        setBloodSugarForm({
                          ...BloodSugarForm,
                          recordNo: formHeading?.length,
                          heading: headNum,
                        });
                        setHypoForm(true);
                      }
                      headNum = headNum[headNum?.length - 1];
                      let compareIndex = headNum == index;
                      if (compareIndex) {
                        dispatch(setBloodSugarComponent({ recordNo: index }));
                        setBloodSugarForm({
                          ...BloodSugarForm,
                          heading: e.target.innerText,
                          recordNo: index,
                        });
                        setHypoForm(false);
                      }
                    }
                  }}
                  sx={{
                    cursor: "pointer",
                    flexDirection: "row",
                    p: 1,
                    mt: 1,
                    backgroundColor:
                      BloodSugarForm?.recordNo == index
                        ? colors.blue
                        : colors.sidebarFormHeading,
                    justifyContent: "space-between",
                  }}
                  disabled={isFormPage && BloodSugarForm?.recordNo !== index} // Disable if not selected or on form page
                >
                  <div
                    style={{
                      color:
                        isFormPage && BloodSugarForm?.recordNo !== index
                          ? "grey"
                          : BloodSugarForm?.recordNo == index
                          ? "white"
                          : "black",
                      // ,
                    }}
                  >
                    {heading}
                  </div>

                  {BloodSugarForm?.recordNo == index ? (
                    <div>
                      <ArrowForwardIosIcon
                        sx={{
                          color: colors.white,
                          fontSize: 15,
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </Stack>
              </>
            );
          })}

          <Button
            className="fw-bold"
            sx={{
              borderRadius: 0,
              fontSize: 11,
              width: "12rem",
              mt: 2.5,
              mb: 1.5,
              backgroundColor: colors.greyHeader,
              "&:hover": {
                color: colors.white,
                backgroundColor: colors.greyHeader,
              },
            }}
            variant="contained"
            onClick={() => {
              if (window.location.pathname === URL.form) {
                navigate(URL.savedRecords);
              } else {
                navigate(URL.visit);
              }
            }}
          >
            {window.location.pathname === URL.form
              ? Language?.ButtonText.backtosaved
              : Language?.ButtonText.backtoVisit}
          </Button>
        </Stack>
      </div>
    </>
  );
}
